var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-sm-5" }, [
      _c("span", { staticClass: "font-weight-bold" }, [
        _vm._v(_vm._s(_vm.pagination.total)),
      ]),
      _vm._v(" registos encontrados"),
      _c("br"),
      _vm._v("\n        A mostrar página "),
      _c("span", { staticClass: "font-weight-bold" }, [
        _vm._v(_vm._s(_vm.pagination.current_page)),
      ]),
      _vm._v(" de "),
      _c("span", { staticClass: "font-weight-bold" }, [
        _vm._v(_vm._s(_vm.pagination.total_pages)),
      ]),
      _vm._v(" "),
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.pagination.per_page,
              expression: "pagination.per_page",
            },
          ],
          staticClass: "ml-2",
          on: {
            change: [
              function ($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function (o) {
                    return o.selected
                  })
                  .map(function (o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.$set(
                  _vm.pagination,
                  "per_page",
                  $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                )
              },
              function ($event) {
                return _vm.reset()
              },
            ],
          },
        },
        _vm._l([5, 10, 25, 50, 100], function (item) {
          return _c("option", { domProps: { value: item } }, [
            _vm._v(_vm._s(item)),
          ])
        }),
        0
      ),
      _vm._v(" \n        registos por página\n    "),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-sm-7" }, [
      _c("nav", { staticClass: "pagination-outer" }, [
        _c(
          "ul",
          { staticClass: "pagination" },
          [
            _vm.pagination.current_page > 1
              ? _c(
                  "li",
                  {
                    staticClass: "page-item",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.changePage(1)
                      },
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "page-link",
                        style: {
                          "background-color": _vm.$store.state.page.bg_color
                            ? _vm.$store.state.page.bg_color
                            : "#b9b9b9",
                          color: _vm.$store.state.page.text_color
                            ? _vm.$store.state.page.text_color
                            : "#fff",
                        },
                        attrs: { href: "#" },
                      },
                      [
                        _c("span", { attrs: { "aria-hidden": "true" } }, [
                          _vm._v("««"),
                        ]),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.pagination.current_page > 1
              ? _c(
                  "li",
                  {
                    staticClass: "page-item",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.changePage(_vm.pagination.current_page - 1)
                      },
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "page-link",
                        style: {
                          "background-color": _vm.$store.state.page.bg_color
                            ? _vm.$store.state.page.bg_color
                            : "#b9b9b9",
                          color: _vm.$store.state.page.text_color
                            ? _vm.$store.state.page.text_color
                            : "#fff",
                        },
                        attrs: { href: "#" },
                      },
                      [
                        _c("span", { attrs: { "aria-hidden": "true" } }, [
                          _vm._v("«"),
                        ]),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.pages, function (page) {
              return _c(
                "li",
                {
                  staticClass: "page-item",
                  class: { active: _vm.isCurrentPage(page) },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      _vm.isCurrentPage(page) ? null : _vm.changePage(page)
                    },
                  },
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "page-link",
                      style: {
                        "background-color": _vm.$store.state.page.bg_color
                          ? _vm.$store.state.page.bg_color
                          : "#b9b9b9",
                        color: _vm.$store.state.page.text_color
                          ? _vm.$store.state.page.text_color
                          : "#fff",
                      },
                      attrs: { href: "#" },
                    },
                    [_vm._v(_vm._s(page))]
                  ),
                ]
              )
            }),
            _vm._v(" "),
            _vm.pagination.current_page < _vm.pagination.last_page
              ? _c(
                  "li",
                  {
                    staticClass: "page-item",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.changePage(_vm.pagination.current_page + 1)
                      },
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "page-link",
                        style: {
                          "background-color": _vm.$store.state.page.bg_color
                            ? _vm.$store.state.page.bg_color
                            : "#b9b9b9",
                          color: _vm.$store.state.page.text_color
                            ? _vm.$store.state.page.text_color
                            : "#fff",
                        },
                        attrs: { href: "#", "aria-label": "Next" },
                      },
                      [
                        _c("span", { attrs: { "aria-hidden": "true" } }, [
                          _vm._v("»"),
                        ]),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.pagination.current_page < _vm.pagination.last_page
              ? _c(
                  "li",
                  {
                    staticClass: "page-item",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.changePage(_vm.pagination.last_page)
                      },
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "page-link",
                        style: {
                          "background-color": _vm.$store.state.page.bg_color
                            ? _vm.$store.state.page.bg_color
                            : "#b9b9b9",
                          color: _vm.$store.state.page.text_color
                            ? _vm.$store.state.page.text_color
                            : "#fff",
                        },
                        attrs: { href: "#", "aria-label": "Next" },
                      },
                      [
                        _c("span", { attrs: { "aria-hidden": "true" } }, [
                          _vm._v("»»"),
                        ]),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
          ],
          2
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }